
import { Box, Text, SimpleGrid, Avatar, HStack, VStack } from "@chakra-ui/react";
import CTAButton from "./CTAButton";

const TestimonialsPreview = () => {
  const testimonials = [
    { name: "Rahul M.", text: "From beginner to AI Developer in 24 weeks!" },
    { name: "Yashwant", text: "The mentor reviews changed everything for me." },
    { name: "Priya S.", text: "Hands-on projects helped me land an ML Engineer role." },
  ];

  return (
    <Box py={16} textAlign="center">
      <Text fontSize="2xl" fontWeight="bold" mb={6}>
        Student Success Stories
      </Text>
      <SimpleGrid columns={[1, 2, 3]} spacing={6}>
        {testimonials.map((t, i) => (
          <Box key={i} p={6} shadow="lg" rounded="xl" bg="gray.50">
            <HStack align="start" spacing={2}>
              <VStack minwidth={75}>
                <Avatar name={t.name} size="lg" />
                <Text mt={2} fontWeight="semibold">{t.name}</Text>
              </VStack>
              <VStack alignItems="center" spacing={2}>
                <Text fontStyle="italic">“{t.text}”</Text>
              </VStack>
            </HStack>
          </Box>
        ))}
      </SimpleGrid>
      <CTAButton mt={6} to="/why-us" variant="solid" size="md">Read More Stories</CTAButton>
    </Box>
  );
};
export default TestimonialsPreview;
